import type { Ticket } from '../types';

function text(value: unknown): string {
  return String(value ?? '').trim();
}

export function mergeTicketPayload(base: Partial<Ticket>, update: Partial<Ticket>, fallbackRunId = ''): Ticket {
  // O faza noua nu mosteneste runul, raportul sau cronometrul activitatii anterioare.
  if (update.workPhase && base.workPhase && update.workPhase !== base.workPhase) {
    const {runId, intervention, interventionReport, activities, observations, partsUsed,
      durationSeconds, durationMinutes, completedAt, ...identity} = base;
    return { ...identity, runId:'', intervention:null, interventionReport:null,
      activities:[], observations:'', partsUsed:[], durationSeconds:0, durationMinutes:0,
      completedAt:null, ...update } as unknown as Ticket;
  }
  const merged = { ...base, ...update } as Ticket;
  const intervention = update.intervention || base.intervention;
  const ticketNumber = update.ticketNumber ?? base.ticketNumber;
  const runId = text(update.runId)
    || text(update.intervention?.runId)
    || text(base.runId)
    || text(base.intervention?.runId)
    || text(fallbackRunId);

  return {
    ...merged,
    ...(ticketNumber !== null && ticketNumber !== undefined && text(ticketNumber) ? { ticketNumber } : {}),
    ...(intervention ? { intervention } : {}),
    ...(runId ? { runId } : {}),
  };
}
